var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mb-0",attrs:{"show":_vm.dismissCountDown,"fade":"","variant":_vm.alertvariant,"dismissible":""},on:{"dismiss-count-down":_vm.countDownChanged}},[_vm._v(" "+_vm._s(_vm.alert.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }